// extracted by mini-css-extract-plugin
export var button = "Form-module--button--HMqNK";
export var buttonRow = "Form-module--buttonRow--3vgPJ";
export var bxTextTruncateEnd = "Form-module--bx--text-truncate--end--3Bqhr";
export var bxTextTruncateFront = "Form-module--bx--text-truncate--front--3c-jU";
export var dialog = "Form-module--dialog--1798f";
export var enter = "Form-module--enter--EJoRS";
export var enterActive = "Form-module--enterActive--PHRZb";
export var exit = "Form-module--exit--5FIlD";
export var exitActive = "Form-module--exitActive--2o-WM";
export var formContainer = "Form-module--form-container--ZiZSL";